import { IconButton } from '@dev-spendesk/grapes';
import { type ReactNode } from 'react';

type Props = {
  title: string;
  children: ReactNode;
  onBack: () => void;
  headerDetails?: ReactNode;
  isLoading?: boolean;
  progress?: number;
};

export const TravelPageWrapper = ({
  children,
  title,
  onBack,
  headerDetails,
  isLoading = false,
  progress = 0,
}: Props) => {
  return (
    <div className="page__container">
      <header className="bg-background-primary-default sticky top-0 z-10 px-40">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-16">
            <IconButton
              variant="secondaryNeutral"
              iconName="arrow-left"
              onClick={onBack}
              aria-label="Back to trips"
            />
            <h1 className="text-content-primary heading-xl py-24">
              <span className="heading-xl">{title}</span>
            </h1>
          </div>
          {headerDetails}
        </div>
        <div className="separator relative bottom-0 h-[1px] w-full" />
        {isLoading && (
          <div className="h-[4px] w-full overflow-hidden">
            <div
              className="bg-background-primary-brand-default rounded-4 h-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
        )}
      </header>
      {children}
    </div>
  );
};
